/**
 * Simple Image Popup Modal
 * Uses jQuery for better compatibility
 */

$(document).ready(function() {
  'use strict';

  // Simple modal functionality
  function openImagePopup(imgElement) {
    var $modal = $('image-popup-modal');
    if ($modal.length === 0) return;
    
    var imageSrc = $(imgElement).data('fullsize') || imgElement.src;
    var imageAlt = $(imgElement).attr('alt') || '';
    
    var $modalImage = $modal.find('.image-popup-modal__image');
    var $modalSpinner = $modal.find('.image-popup-spinner');
    
    // Reset spinner
    $modalSpinner.removeClass('hidden');
    $modalImage.removeClass('loaded');
    
    // Set image source
    $modalImage.attr('src', imageSrc).attr('alt', imageAlt);
    
    // Show modal
    $modal.attr('open', '');
    $('body').addClass('image-popup-open').css('overflow', 'hidden');
    
    // Focus close button
    $modal.find('.image-popup-modal__close').focus();
    
    // Handle image load
    $modalImage.on('load.imagepopup', function() {
      $(this).addClass('loaded');
      $modalSpinner.addClass('hidden');
    });
    
    // Handle image error
    $modalImage.on('error.imagepopup', function() {
      $modalSpinner.addClass('hidden');
    });
  }

  // Gallery functionality
  function openImageGallery(containerElement) {
    var $modal = $('image-popup-modal');
    if ($modal.length === 0) return;
    
    var $images = $(containerElement).find('img');
    if ($images.length === 0) return;
    
    var $modalImage = $modal.find('.image-popup-modal__image');
    var $modalSpinner = $modal.find('.image-popup-spinner');
    var $thumbnails = $modal.find('.image-popup-modal__thumbnails');
    var $thumbnailsContainer = $modal.find('.image-popup-modal__thumbnails-container');
    
    // Create thumbnails
    $thumbnailsContainer.empty();
    $images.each(function(index) {
      var $img = $(this);
      var thumbnailSrc = $img.attr('src');
      var thumbnailAlt = $img.attr('alt') || '';
      
      var $thumbnail = $('<div class="image-popup-modal__thumbnail" data-index="' + index + '">' +
        '<img src="' + thumbnailSrc + '" alt="' + thumbnailAlt + '">' +
        '</div>');
      
      $thumbnailsContainer.append($thumbnail);
    });
    
    // Show thumbnails
    $thumbnails.removeClass('hidden');
    
    // Set first image
    var firstImage = $images.first();
    var imageSrc = firstImage.data('fullsize') || firstImage.attr('src');
    var imageAlt = firstImage.attr('alt') || '';
    
    // Reset spinner
    $modalSpinner.removeClass('hidden');
    $modalImage.removeClass('loaded');
    
    $modalImage.attr('src', imageSrc).attr('alt', imageAlt);
    
    // Mark first thumbnail as active
    $thumbnailsContainer.find('.image-popup-modal__thumbnail').first().addClass('active');
    
    // Show modal
    $modal.attr('open', '');
    $('body').addClass('image-popup-open').css('overflow', 'hidden');
    
    // Focus close button
    $modal.find('.image-popup-modal__close').focus();
    
    // Handle image load
    $modalImage.on('load.imagepopup', function() {
      $(this).addClass('loaded');
      $modalSpinner.addClass('hidden');
    });
    
    // Handle image error
    $modalImage.on('error.imagepopup', function() {
      $modalSpinner.addClass('hidden');
    });
    
    // Store gallery data for thumbnail clicks
    $modal.data('galleryImages', $images);
  }

  function closeImagePopup() {
    var $modal = $('image-popup-modal');
    $modal.removeAttr('open');
    $('body').removeClass('image-popup-open').css('overflow', '');
    
    // Hide thumbnails
    $modal.find('.image-popup-modal__thumbnails').addClass('hidden');
  }

  // Event handlers
  $(document).on('click', '[data-img-action="popup"]', function() {
    openImagePopup(this);
  });

  $(document).on('click', '[data-img-action="gallery"]', function(e) {
    // Don't trigger if clicking directly on an image with data-img-action="popup"
    if ($(e.target).attr('data-img-action') === 'popup') return;
    openImageGallery(this);
  });

  $(document).on('click', '.image-popup-modal__close', closeImagePopup);
  
  $(document).on('click', '.image-popup-modal__overlay', function(e) {
    if (e.target === this) closeImagePopup();
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $('image-popup-modal[open]').length) {
      closeImagePopup();
    }
  });

  // Thumbnail click handler
  $(document).on('click', '.image-popup-modal__thumbnail', function() {
    var $modal = $('image-popup-modal');
    var $galleryImages = $modal.data('galleryImages');
    var index = parseInt($(this).attr('data-index'));
    
    if ($galleryImages && $galleryImages.length > index) {
      var $selectedImage = $galleryImages.eq(index);
      var imageSrc = $selectedImage.data('fullsize') || $selectedImage.attr('src');
      var imageAlt = $selectedImage.attr('alt') || '';
      
      var $modalImage = $modal.find('.image-popup-modal__image');
      var $modalSpinner = $modal.find('.image-popup-spinner');
      
      // Reset spinner
      $modalSpinner.removeClass('hidden');
      $modalImage.removeClass('loaded');
      
      $modalImage.attr('src', imageSrc).attr('alt', imageAlt);
      
      // Update active thumbnail
      $modal.find('.image-popup-modal__thumbnail').removeClass('active');
      $(this).addClass('active');
    }
  });

});
